import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { Augmentation } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface LabelAugmentationsModel {
  labelAugmentationsMap: Record<string, Augmentation>;
  setLabelAugmentations: Action<LabelAugmentationsModel, Augmentation[]>;
  setLabelAugmentation: Action<LabelAugmentationsModel, Augmentation>;
  fetchLabelAugmentationsLoading: boolean;
  setFetchLabelAugmentationsLoading: Action<LabelAugmentationsModel, boolean>;
  fetchLabelAugmentation: Thunk<LabelAugmentationsModel, void, Injections, StoreModel, Promise<void>>;
  fetchLabelAugmentationsFailure: Action<LabelAugmentationsModel, ApplicationErrorOptions>;
}

export const labelAugmentationsModel: LabelAugmentationsModel = {
  labelAugmentationsMap: {},
  setLabelAugmentations: action((state, labelAugmentations) => {
    const labelAugmentationsMap = labelAugmentations.reduce<Record<string, Augmentation>>((acc, curr) => {
      acc[curr.labelAugmentationId] = curr;
      return acc;
    }, {});
    state.labelAugmentationsMap = labelAugmentationsMap;
  }),
  setLabelAugmentation: action((state, labelAugmentation) => {
    state.labelAugmentationsMap[labelAugmentation.labelAugmentationId] = labelAugmentation;
  }),
  fetchLabelAugmentationsLoading: false,
  setFetchLabelAugmentationsLoading: action((state, isLoading) => {
    state.fetchLabelAugmentationsLoading = isLoading;
  }),
  fetchLabelAugmentation: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchLabelAugmentationsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchLabelAugmentations();
      actions.setLabelAugmentations(response);
      actions.setFetchLabelAugmentationsLoading(false);
      return response;
    } catch (error) {
      actions.fetchLabelAugmentationsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchLabelAugmentationsLoading(false);
      return error;
    }
  }),
  fetchLabelAugmentationsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default labelAugmentationsModel;
